import React, { useState, Fragment, useEffect } from 'react';
import Layout from '../../Layout/Layout';
import DataTable from "react-data-table-component";
import { Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { RiDeleteBin5Line } from "react-icons/ri";
import { FaRegEdit } from "react-icons/fa";
import { deletfaq, getfaqlist } from '../../actions/users';
import { toast } from 'react-toastify';
import moment from 'moment';

const FaqList = () => {

    const navigate = useNavigate();

    const [faqList, setFaqList] = useState([
        {
            "EmailAddress": "dummy@gmial.com",
            "Name": "maticz",
            "Subject": "summy subject",
            "Detail": "dummy detailssss",
            "NFTCategory": "dummy detailssss",
            "NFTRoyality": "dummy detailssss",
            "ListStatus": "dummy detailssss",
            "ListedQuantity": "dummy detailssss",
            "NFTQuantity": "dummy detailssss",
        },
    ]);
    const [pageNumber, setPageNumber] = useState(1);
    const [limit, setLimit] = useState(10);


    function editR(id) {
        // alert(e.target.id);
        if (id != '') {
            // window.location="/ecafade/faqedit/"+id;
            navigate({
                pathname: "/faqedit/" + id._id,
                state: {
                    items: id
                }
            })
        }

    }
    // const viewuser = (e) => {
        // 
    // }
    async function deleteR(id) {
        if (id != '') {
            await deletfaq(id);
            toast.success('Faq deleted successfully', 1000);
            getFaqList();
            //window.location="/faqlist";
        }
    }


    const getFaqList = async () => {
        var test = await getfaqlist();
        
        setFaqList(test.userValue);
    }
    const add = async () => {
        window.location = "/ecafade/faqadd";
    }

    const getAll = async (search = {}) => {
        let filterData = search;
        if (filterData.search == '') {
            filterData = {}
        }
        var res = await getfaqlist(filterData);
        setFaqList(res.userValue);
    }

    useEffect(() => {
        getFaqList();
    }, []);

    const columns = [

        {

            key: "sno",
            name: "S.No",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => (
                <p>
                    {/* {(((pageNumber-1)*limit)+((((pageNumber*limit)>userList?.length))?(index):(index + 1)))} */}
                    {(((pageNumber-1)*limit)+(index + 1))}
                </p>
            ),

        },
        {

            key: "Question",
            name: "Question",
            // // className: "tokenId",
            align: "left",
            sortable: false,
            cell: (row, index, column, id) => (
                <p>{row?.question}</p>
            ),

        },        
        // {

        //     key: "Date",
        //     name: "Date",
        //     // // className: "tokenId",
        //     align: "left",
        //     sortable: false,
        //     cell: (row, index, column, id) => (
        //         <p>{moment(row.date).format('MMMM,Do YYYY, hh:mm A')}</p>
        //     ),

        // },        
        {

            key: "Action",
            name: "Action",
            // className: "tokenQuantity",
            align: "left",
            sortable: false, cell: record => {
                return (
                    <Fragment>
                        <button
                            data-toggle="modal"
                            className="btn btn-primary btn-sm"
                            onClick={() => editR(record)}

                            style={{ marginRight: '5px' }}
                        >
                            <FaRegEdit />
                        </button>
                        <button
                            data-toggle="modal"
                            className="btn btn-danger btn-sm"
                            onClick={() => deleteR(record._id)}

                            style={{ marginRight: '5px' }}
                        >
                            <RiDeleteBin5Line />
                        </button>
                    </Fragment>
                );
            }

        },
    ];

    function pageRowChange (page, row) {
        
        setPageNumber(page);
        setLimit(row);
    }

    return (
        <Layout>
            <div className="faqlist">
                <div className="d-flex align-items-center justify-content-between mb-4">
                    <h1 className="pagehead mb-0">Faq List</h1>
                    <Link to="/faqadd" className="btn sitebtn py-2 px-3">Add</Link>
                </div>
                <div className="cardbox">
                    <div className="tablebox">
                        {/* <Form.Control type="text" placeholder="Filter in records" /> */}
                        <DataTable
                            className='react-datatables'
                            columns={columns}
                            data={faqList}
                            pagination // Enable pagination
                            // paginationPerPage={2} // Rows per page
                            paginationRowsPerPageOptions={[5, 10, 15, 20]}
                            onChangePage={(page,totalRows)=>pageRowChange(page,limit)}
                            onChangeRowsPerPage={(totalRows, page)=>pageRowChange(page,totalRows)}
                        />
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default FaqList;